import {Platform} from 'react-native';
import {BlurView} from '@react-native-community/blur';
import {TouchableOpacity} from 'react-native';
import styled from 'styled-components/native';
import {RFValue} from 'react-native-responsive-fontsize';

export const TAB_HEIGHT = RFValue(50);
export const CENTER_BUTTON_SIZE = RFValue(45);
export const CENTER_OVERLAP = RFValue(23);

export const Wrapper = styled.View`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  
  bottom: 0;
`;

export const FloatingWrapper = styled.View<{$bottom: number}>`
  position: absolute;
  left: 16px;
  right: 16px;
  height: ${TAB_HEIGHT}px;
  bottom: ${({$bottom}) => $bottom}px;
  ${Platform.OS === 'ios'
    ? `shadow-color: #000;
       shadow-offset: 0px 8px;
       shadow-opacity: 0.15;
       shadow-radius: 24px;`
    : ''}
`;

export const ShadowLayer = styled.View`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;

  border-radius: 24px;
  elevation: 12;
`;

export const BlurClip = styled.View`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border-radius: 32px;
  overflow: hidden;
`;

export const StyledBlurView = styled(BlurView)`
  flex: 1;
 
`;

export const Overlay = styled.View<{$isDark: boolean}>`
  flex: 1;
  flex-direction: row;
  align-items: center;
  padding-left: 8px;
  padding-right: 8px;
  background-color: ${({$isDark}) =>
    $isDark ? 'rgba(30,30,30,0.3)' : 'rgba(255,255,255,0.025)'};
`;

export const Tab = styled(TouchableOpacity)`
  flex: 1;
  align-items: center;
  justify-content: center;
  padding-top: 4px;
  padding-bottom: 4px;
  gap: 2px;
  border-radius: ${RFValue(32)}px;
`;

export const IconContainer = styled.View`
  border-radius: 16px;
  padding-horizontal: 14px;
  padding-vertical: 1px;
  align-items: center;
  justify-content: center;
`;

export const Label = styled.Text<{$color: string; $fontFamily: string}>`
  font-size: ${RFValue(8.6)}px;
  text-align: center;
  color: ${({$color}) => $color};
  font-family: ${({$fontFamily}) => $fontFamily};
`;

export const CenterButtonOuter = styled.View<{$bottom: number}>`
  position: absolute;
  left: 0;
  right: 0;
  align-items: center;
  bottom: ${({$bottom}) => $bottom}px;
`;

export const CenterBlurView = styled.View`
  width: ${CENTER_BUTTON_SIZE}px;
  height: ${CENTER_BUTTON_SIZE}px;
  border-radius: ${CENTER_BUTTON_SIZE / 2}px;
  overflow: hidden;
   justify-content: center;
   align-items: center;
`;

export const CenterSpace = styled.View`
  height: ${RFValue(12)};
`;
